module.exports = __webpack_public_path__ + "static/media/Huawei.6191a22e.svg";